<template lang="pug">
  v-col.pb-5(cols="12" md="6" sm="6" v-if="currentBanner")
    .flash-banner
      .banner-container
        img(:src="currentBanner.src" @click="openBanner()" :style="currentBanner.link ? 'cursor: pointer' : ''")
        .close-button(@click="closeBanner()")
          .close-icon

</template>
<script>
import { mapState, mapActions } from 'vuex'
import { getLocale } from '../../../i18n'

export default {
  data: () => ({
    flashBannersJSON: null,
  }),

  computed: {
    ...mapState({
      currentBanner: state => state.tools.currentFlashBanner,
    }),

    locale() {
      return getLocale()
    },
  },

  mounted() {
    this.firebaseRemoteConfigGetString('FLASH_BANNERS').then((result) => {
      try {
        this.flashBannersJSON = JSON.parse(result)[this.locale]
        this.selectCurrentBanner()
      } catch (error) {
        // console.debug(error)
      }
    })
  },

  methods: {
    ...mapActions({
      setCurrentFlashBanner: 'tools/setCurrentFlashBanner',
      firebaseRemoteConfigGetString: 'tools/firebaseRemoteConfigGetString',
      analyticsLogEvent: 'analytics/logEvent',
    }),

    selectCurrentBanner() {
      if (!this.flashBannersJSON || !Array.isArray(this.flashBannersJSON)) {
        return
      }

      const today = new Date()
      const closedBanners = this.getClosedBanners()

      // Фильтруем баннеры по актуальным датам
      const activeBanners = this.flashBannersJSON.filter(banner => {
        const startDate = new Date(banner.startDate)
        const endDate = new Date(banner.endDate)
        return today >= startDate && today <= endDate
      })

      // Сортируем по приоритету (ascending - меньшее число = выше приоритет)
      activeBanners.sort((a, b) => a.priority - b.priority)

      // Ищем первый баннер, который не закрыт пользователем
      const selectedBanner = activeBanners.find(banner => !closedBanners.includes(banner.id))

      this.setCurrentFlashBanner(selectedBanner || null)

      if (selectedBanner) {
        this.analyticsLogEvent({
          eventName: 're_dash_flashbanner_showed',
          eventProperties: {
            flashbanner_name: this.currentBanner.id,
            flashbanner_start_date: this.$moment(this.currentBanner.startDate).format('DD-MM-YYYY'),
            flashbanner_end_date: this.$moment(this.currentBanner.endDate).format('DD-MM-YYYY'),
            flashbanner_link: this.currentBanner.link,
          },
        })
      }
    },

    getClosedBanners() {
      try {
        const closed = localStorage.getItem('closedFlashBanners')
        return closed ? JSON.parse(closed) : []
      } catch (error) {
        return []
      }
    },

    addToClosedBanners(bannerId) {
      try {
        const closedBanners = this.getClosedBanners()
        if (!closedBanners.includes(bannerId)) {
          closedBanners.push(bannerId)
          localStorage.setItem('closedFlashBanners', JSON.stringify(closedBanners))
        }
      } catch (error) {
        // console.debug('Error saving closed banner:', error)
      }
    },

    openBanner() {
      if (this.currentBanner.link) {
        this.$openLink(this.currentBanner.link, '_system')
        this.analyticsLogEvent({
          eventName: 're_dash_flashbanner_link_clicked',
          eventProperties: {
            flashbanner_name: this.currentBanner.id,
            flashbanner_start_date: this.$moment(this.currentBanner.startDate).format('DD-MM-YYYY'),
            flashbanner_end_date: this.$moment(this.currentBanner.endDate).format('DD-MM-YYYY'),
            flashbanner_link: this.currentBanner.link,
          },
        })
      }
    },

    closeBanner() {
      if (this.currentBanner) {
        this.addToClosedBanners(this.currentBanner.id)

        this.analyticsLogEvent({
          eventName: 're_dash_flashbanner_link_closed',
          eventProperties: {
            flashbanner_name: this.currentBanner.id,
            flashbanner_start_date: this.$moment(this.currentBanner.startDate).format('DD-MM-YYYY'),
            flashbanner_end_date: this.$moment(this.currentBanner.endDate).format('DD-MM-YYYY'),
            flashbanner_link: this.currentBanner.link,
          },
        })

        this.setCurrentFlashBanner(null)
      }
    },
  },
}
</script>
<style lang="stylus">
.flash-banner
  display flex
  justify-content center
  align-items center

  .banner-container
    position relative
    display inline-block
    width 100%
    max-width 600px

  img
    width 100%
    display block
    border-radius 16px

  .close-button
    position absolute
    top 10px
    right 10px
    width 24px
    height 24px
    background rgba(0, 0, 0, 0.2)
    border-radius 50%
    cursor pointer
    display flex
    align-items center
    justify-content center

    .close-icon
      position relative
      width 14px
      height 14px

      &::before,
      &::after
        content ''
        position absolute
        top 50%
        left 50%
        width 14px
        height 2px
        background #ffffff
        border-radius 1px
        transform-origin center

      &::before
        transform translate(-50%, -50%) rotate(45deg)

      &::after
        transform translate(-50%, -50%) rotate(-45deg)
</style>
